import * as React from 'react';
import parse from "html-react-parser";

export interface PanelProps {
    id: string;
    severity: number;
    title: string;
    content: string;
    onClose: any;
}

export default class Panel extends React.Component<PanelProps, {}> {
    state = {
        isClosed: false,
    };

    close() {
        this.setState({isClosed: true});
        this.props.onClose(this.props.id);
    };

    render() {
        let icon;
        if (this.props.severity > 0) {
            icon = <svg xmlns="http://www.w3.org/2000/svg" width="22"
                        height="20" viewBox="0 0 22 20">
                <g fill="#FFF" fillRule="nonzero">
                    <path
                        d="M10.907 14.053c-.61 0-1.121.511-1.121 1.121s.511 1.121 1.121 1.121c.587 0 1.121-.511 1.094-1.094a1.095 1.095 0 0 0-1.094-1.148z"/>
                    <path
                        d="M21.284 18.026a3.828 3.828 0 0 0 .009-3.874L14.27 1.99A3.815 3.815 0 0 0 10.911.04a3.83 3.83 0 0 0-3.358 1.946L.52 14.16a3.859 3.859 0 0 0 .014 3.896 3.838 3.838 0 0 0 3.35 1.924H17.91c1.404 0 2.664-.73 3.373-1.955zm-1.525-.879a2.12 2.12 0 0 1-1.852 1.072H3.88a2.09 2.09 0 0 1-1.83-1.05 2.122 2.122 0 0 1-.004-2.138L9.077 2.86a2.08 2.08 0 0 1 1.834-1.064c.767 0 1.453.4 1.835 1.068l7.026 12.17a2.094 2.094 0 0 1-.013 2.112z"/>
                    <path
                        d="M10.629 6.183c-.534.153-.866.637-.866 1.224.027.355.05.713.077 1.068l.228 4.022c.027.457.382.79.839.79a.838.838 0 0 0 .839-.817c0-.278 0-.534.026-.816.05-.866.104-1.731.153-2.597.027-.56.076-1.12.103-1.681 0-.202-.027-.381-.103-.56a1.124 1.124 0 0 0-1.296-.633z"/>
                </g>
            </svg>;
        } else {
            icon = <svg xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" viewBox="0 0 20 20">
                <g fill="#FFF" fillRule="nonzero">
                    <path
                        d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18.182c-4.512 0-8.182-3.67-8.182-8.182 0-4.511 3.67-8.182 8.182-8.182 4.512 0 8.182 3.67 8.182 8.182 0 4.512-3.67 8.182-8.182 8.182z"/>
                    <path
                        d="M10 4.242a1.213 1.213 0 1 0 1.212 1.213c0-.669-.544-1.213-1.212-1.213zM10 8.485a.91.91 0 0 0-.91.909v5.454a.91.91 0 0 0 1.82 0V9.394a.91.91 0 0 0-.91-.91z"/>
                </g>
            </svg>;
        }

        let title;
        if (this.props.title) {
            title = <h2 className="cc-panel_content_title">{this.props.title}</h2>
        }

        let classNames = 'cc-panel';
        classNames += this.props.severity > 0 ? ' cc-panel--warning' : ' cc-panel--info';
        classNames += this.state.isClosed ? ' cc-panel--closed' : '';

        return (
            <div className={classNames}>
                <div className="cc-panel_badge">
                    <div className="cc-panel_badge_icon cc-panel_badge_icon">
                        {icon}
                    </div>
                </div>
                <div className="cc-panel_content">
                    {title}
                    <div data-content="">
                        {parse(this.props.content)}
                    </div>
                </div>
                <div className="cc-panel_close" data-close onClick={(event: React.MouseEvent<HTMLElement>) => {
                    this.close();
                }}>
                </div>
            </div>
        );
    }
}
